import { dataCubeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCubeSolid = /*#__PURE__*/createIcon(dataCubeSolid)
export default IconCubeSolid
